import React from 'react';
import PageHeader from './pageHeader';
import PageFooter from './pageFooter';

const Layout = ({ children }) => {
  return (
    <div className="wrapper">
      <main className="main">
        <PageHeader />

        {children}

        <PageFooter />
      </main>
    </div>
  );
};

export default Layout;
